import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Chip, MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { I18n } from 'aws-amplify';
import _ from 'lodash';

export default function SettingChatPermissionForm({ props, argsAll }) {
    const knowledgeTicketChatPermissions = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT;

    const onChangeSelectedChatPermission = event => {
        let chatPermissionValue = event.target.value;
        argsAll.setSelectedChatPermissions(chatPermissionValue);
        if (chatPermissionValue.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
    };

    useEffect(() => {
        if (argsAll.formEdit) {
            argsAll.setSelectedChatPermissions(
                knowledgeTicketChatPermissions[argsAll.formEdit.chatPermission]
            );
        }
    }, []);

    return (
        <>
            <div className="lstCreateForm padding-0">
                <label className="share-option-text">基本権限</label>
                <div className="share-option-control">
                    <TextField
                        name="share-option"
                        className="form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        value={argsAll.selectedChatPermissions}
                        onChange={onChangeSelectedChatPermission}
                        defaultValue={
                            argsAll.formEdit && argsAll.formEdit?.chatPermission
                                ? argsAll.formEdit.chatPermission
                                : Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT
                        }
                        disabled={argsAll.isFormReadOnly}
                    >
                        {!Utils.isEmptyArray(argsAll.listOptionChatPermission) &&
                            argsAll.listOptionChatPermission?.map((item, i) => {
                                return (
                                    <MenuItem key={i} value={item}>
                                        {item}
                                    </MenuItem>
                                );
                            })}
                    </TextField>
                </div>
            </div>
        </>
    );
}
